// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"358":"09a444ee","415":"bfbb7da7"}[chunkId] + ".css";
};